export default "__VITE_ASSET__BCFsqWd2__"